import React from 'react';
import { Button } from '@mui/material';

// Gradient tones mirror the flat btn-custom-* color code in assets/css/buttons.css
const TONES = {
  confirm: {
    from: '#00c9a4',
    to: '#00806a',
    shadow: '0,158,130',
    text: 'white',
  },
  cancel: {
    from: '#ff9ecf',
    to: '#e05fa3',
    shadow: '252,134,193',
    text: 'white',
  },
  back: {
    from: '#ffc9a3',
    to: '#e8895f',
    shadow: '252,173,137',
    text: 'white',
  },
  info: { from: '#64b5f6', to: '#1e88e5', shadow: '66,165,245', text: 'white' },
  highlight: {
    from: '#FFD54F',
    to: '#e3a406',
    shadow: '255,199,39',
    text: '#1a2240',
  },
};

// Shared touchscreen button: 90px tall, gradient, color-coded by tone
function TouchButton({ tone = 'confirm', sx = {}, children, ...props }) {
  const c = TONES[tone] || TONES.confirm;

  return (
    <Button
      variant="contained"
      disableElevation
      sx={{
        background: `linear-gradient(160deg, ${c.from} 0%, ${c.to} 100%)`,
        color: c.text,
        minWidth: '260px',
        height: '90px',
        px: 4,
        fontSize: '24px',
        fontWeight: 800,
        letterSpacing: '0.02em',
        textTransform: 'none',
        borderRadius: '12px',
        boxShadow: `0 6px 18px rgba(${c.shadow},0.35), inset 0 1px 0 rgba(255,255,255,0.14)`,
        transition: 'transform 80ms ease, box-shadow 80ms ease',
        '& .MuiButton-startIcon > *': { fontSize: '32px' },
        // press feedback; :hover is stripped app-wide by the stylis plugin
        '&:active': {
          transform: 'translateY(3px)',
          boxShadow: `0 2px 8px rgba(${c.shadow},0.3), inset 0 1px 0 rgba(255,255,255,0.1)`,
        },
        '&.Mui-disabled': {
          background: '#232a45',
          color: '#4a5578',
          boxShadow: 'none',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

export default TouchButton;
